<template>
  <div
    class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center"
  >
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
          <router-link
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3"
            to="/subscribers"
          >
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold text-green-500 ">
            {{$t('new_subscriber')}}
          </div>
          <div v-else class="text-2xl font-bold text-green-500 ">
           {{$t('edit_subscriber')}}
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6">
          <!-- Basic Information Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">{{$t('basic_information')}}</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 px-10">
              <!-- Full Name -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="fullName" class="bg-white text-gray-700 px-1">{{$t('full_name')}}<span :class="$colors.required">*</span></label>
                  </p>
                </div>
                <p>
                  <input id="fullName" autocomplete="false" tabindex="0" type="text" v-model="formData.fullName" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Email -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="email" class="bg-white text-gray-700 px-1">{{$t('email')}} <span :class="$colors.required">*</span></label>
                  </p>
                </div>
                <p>
                  <input id="email" autocomplete="false" tabindex="0" type="text" v-model="formData.email" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Phone (WhatsApp) -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="phone" class="bg-white text-gray-700 px-1">{{$t('phone')}} (WhatsApp) <span :class="$colors.required">*</span></label>
                  </p>
                </div>
                <p>
                  <input id="phone" autocomplete="false" tabindex="0" type="text" v-model="formData.phone" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- City -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="city" class="bg-white text-gray-700 px-1">{{$t('city')}}</label>
                  </p>
                </div>
                <p>
                  <input id="city" autocomplete="false" tabindex="0" type="text" v-model="formData.city" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Country (warehouse) -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="customerPhone" class="bg-white text-gray-700 px-1">{{$t('country')}} (warehouse) <span :class="$colors.required">*</span></label>
                  </p>
                </div>
                <p>
                  <v-select @input="setSelectedContry" v-model="formData.country" :options="warehouses" label="countryName">
                    <template slot="option" slot-scope="option">
                      <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                      {{ option.countryName }}
                    </template>
                  </v-select>
                </p>
              </div>

              <!-- Country of origin (informatif — landing page) -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="originCountry" class="bg-white text-gray-700 px-1">{{$t('country_of_origin') || "Pays d'origine"}}</label>
                  </p>
                </div>
                <p>
                  <input id="originCountry" autocomplete="false" tabindex="0" type="text" v-model="formData.originCountry" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Account type (seller / affiliate) — vient du landing -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="accountType" class="bg-white text-gray-700 px-1">{{$t('account_type') || 'Type de compte'}}</label>
                  </p>
                </div>
                <p>
                  <select id="accountType" v-model="formData.accountType" class="py-2 text-xs px-2 outline-none block h-full w-full bg-white">
                    <option value="seller">Seller</option>
                    <option value="affiliate">Affiliate</option>
                    <option value="cpa">CPA</option>
                  </select>
                </p>
              </div>
            </div>
          </div>

          <!-- Experience Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">{{$t('experience_information')}}</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 px-10">
              <!-- Experience Level -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="experienceLevel" class="bg-white text-gray-700 px-1">{{$t('experience_ecommerce')}}</label>
                  </p>
                </div>
                <p>
                  <select id="experienceLevel" v-model="formData.experienceLevel" class="py-2 text-xs px-2 outline-none block h-full w-full bg-white">
                    <option value="Beginner">{{$t('beginner')}}</option>
                    <option value="Intermediate">{{$t('intermediate')}}</option>
                    <option value="Advanced">{{$t('advanced')}}</option>
                  </select>
                </p>
              </div>

              <!-- Has Affiliate Experience -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="hasAffiliateExperience" class="bg-white text-gray-700 px-1">{{$t('affiliate_experience')}}</label>
                  </p>
                </div>
                <p>
                  <select id="hasAffiliateExperience" v-model="formData.hasAffiliateExperience" class="py-2 text-xs px-2 outline-none block h-full w-full bg-white">
                    <option :value="false">{{$t('no')}}</option>
                    <option :value="true">{{$t('yes')}}</option>
                  </select>
                </p>
              </div>

              <!-- Affiliate Platforms (shown only if hasAffiliateExperience is true) -->
              <div v-if="formData.hasAffiliateExperience" class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1 md:col-span-2">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="affiliatePlatforms" class="bg-white text-gray-700 px-1">{{$t('affiliate_platforms')}}</label>
                  </p>
                </div>
                <p>
                  <input id="affiliatePlatforms" autocomplete="false" tabindex="0" type="text" v-model="affiliatePlatformsString" :placeholder="$t('platforms_placeholder')" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Average Daily Leads -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="averageDailyLeads" class="bg-white text-gray-700 px-1">{{$t('average_daily_leads')}}</label>
                  </p>
                </div>
                <p>
                  <input id="averageDailyLeads" autocomplete="false" tabindex="0" type="number" v-model="formData.averageDailyLeads" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Highest Daily Ad Spend -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="highestDailyAdSpend" class="bg-white text-gray-700 px-1">{{$t('highest_daily_ad_spend')}}</label>
                  </p>
                </div>
                <p>
                  <input id="highestDailyAdSpend" autocomplete="false" tabindex="0" type="number" v-model="formData.highestDailyAdSpend" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                </p>
              </div>

              <!-- Work Type -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="workType" class="bg-white text-gray-700 px-1">{{$t('work_type')}}</label>
                  </p>
                </div>
                <p>
                  <select id="workType" v-model="formData.workType" class="py-2 text-xs px-2 outline-none block h-full w-full bg-white">
                    <option value="Individual">{{$t('individual')}}</option>
                    <option value="Team">{{$t('team')}}</option>
                  </select>
                </p>
              </div>
            </div>
          </div>

          <!-- Objectives Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">{{$t('objectives')}}</h3>
            <div class="space-y-4 px-10">
              <!-- Main Objective -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="mainObjective" class="bg-white text-gray-700 px-1">{{$t('main_objective')}}</label>
                  </p>
                </div>
                <p>
                  <textarea id="mainObjective" rows="3" v-model="formData.mainObjective" class="py-2 text-xs px-2 outline-none block h-full w-full"></textarea>
                </p>
              </div>

              <!-- Additional Notes -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="additionalNotes" class="bg-white text-gray-700 px-1">{{$t('additional_notes')}}</label>
                  </p>
                </div>
                <p>
                  <textarea id="additionalNotes" rows="3" v-model="formData.additionalNotes" class="py-2 text-xs px-2 outline-none block h-full w-full"></textarea>
                </p>
              </div>
            </div>
          </div>

          <!-- Status Section (only shown when editing) -->
          <div v-if="formData._id" class="mb-6">
            <h3 class="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">{{$t('status_information')}}</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 px-10">
              <!-- Status Display -->
              <div class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label class="bg-white text-gray-700 px-1">{{$t('status')}}</label>
                  </p>
                </div>
                <p class="py-2 px-2">
                  <span v-if="formData.status === 'Pending'" class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                    {{$t('pending')}}
                  </span>
                  <span v-else-if="formData.status === 'Converted'" class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    {{$t('converted')}}
                  </span>
                  <span v-else-if="formData.status === 'Rejected'" class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                    {{$t('rejected')}}
                  </span>
                </p>
              </div>

              <!-- Rejection Reason (only if rejected) -->
              <div v-if="formData.status === 'Rejected'" class="border hover:border-green-500 w-full focus-within:border-blue-500 focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label class="bg-white text-gray-700 px-1">{{$t('rejection_reason')}}</label>
                  </p>
                </div>
                <p class="py-2 px-2 text-xs text-gray-600">
                  {{ formData.rejectionReason || '-' }}
                </p>
              </div>
            </div>
          </div>

          <div class="mt-6 pt-3 flex justify-center">
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300"
              @click="save"
            >
              {{$t('save')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- ******************* Partie Script *********************** -->
<script>
export default {
  data() {
    return {
      formData: {
        experienceLevel: 'Beginner',
        hasAffiliateExperience: false,
        affiliatePlatforms: [],
        workType: 'Individual',
        status: 'Pending'
      },
      warehouses:[],
      selectContry:'',
      options:this.$countries,
      affiliatePlatformsString: ''
    };
  },
  watch: {
    affiliatePlatformsString(newVal) {
      // Convert comma-separated string to array
      if (newVal) {
        this.formData.affiliatePlatforms = newVal.split(',').map(s => s.trim()).filter(s => s);
      } else {
        this.formData.affiliatePlatforms = [];
      }
    }
  },
  async mounted() {
    await this.dataToEdit();
    await this.getWarehouses();
  },
  methods: {
    async getWarehouses(){
      const filter = {limit:100};
      const res = await this.$server.search("warehouses",filter);
      if (res.content.results) {
          this.warehouses = res.content.results;
      } else this.warehouses = [];
    },
    async setSelectedContry(contry) {
      if(contry){
        if(typeof this.formData.country === 'object' && this.formData.country !== null) {
          this.formData.country = this.formData.country.countryName;
        }
      }
    },
    async save() {
      if (this.formData._id) {
        var count = this.formData.country.length;
        if(count>2) this.formData.country = this.$f.getCountryCodeByName(this.options,this.formData.country);
        const data = await this.$server.update("subscribers", this.formData);
        if (data._id) {
          alert(this.$t('subscriber_updated'), "success");
        }
      } else {
        if (this.checkData()) {
          var count = this.formData.country.length;
          if(count>2) this.formData.country = this.$f.getCountryCodeByName(this.options,this.formData.country);

          const data = await this.$server.create("subscribers", this.formData);

          if (data._id) {
            this.selectContry="";
            this.formData = {
              experienceLevel: 'Beginner',
              hasAffiliateExperience: false,
              affiliatePlatforms: [],
              workType: 'Individual',
              status: 'Pending'
            };
            this.affiliatePlatformsString = '';
            alert(this.$t('subscriber_created'), "success");
          }
        } else {
          alert(this.$t('all_required_field'), "warning");
        }
      }
    },
    checkData() {
      const requiredFiels = ["fullName", "phone", "email","country"];
      for (let index = 0, len = requiredFiels.length; index < len; index++) {
        if (!(requiredFiels[index] in this.formData) || !this.formData[requiredFiels[index]]) return false;
      }
      return true;
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("subscribers", {
          id: this.$route.params.id,
        });
        this.formData = editData.content;

        // Handle country display
        if (this.formData.country) {
          var count = this.formData.country.length;
          if(count==2) this.formData.country = this.$f.getCountryNameByCode(this.options,this.formData.country);
        }

        // Convert affiliatePlatforms array to string for display
        if (this.formData.affiliatePlatforms && Array.isArray(this.formData.affiliatePlatforms)) {
          this.affiliatePlatformsString = this.formData.affiliatePlatforms.join(', ');
        }

        // Set defaults for new fields if not present
        if (!this.formData.experienceLevel) this.formData.experienceLevel = 'Beginner';
        if (this.formData.hasAffiliateExperience === undefined) this.formData.hasAffiliateExperience = false;
        if (!this.formData.workType) this.formData.workType = 'Individual';
        if (!this.formData.status) this.formData.status = 'Pending';
      }
    },
  },
};
</script>

<!-- ******************* Partie style *********************** -->
<style >
</style> 